var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3V0.75L6 3.75L9 6.75V4.5C11.4825 4.5 13.5 6.5175 13.5 9C13.5 9.7575 13.3125 10.4775 12.975 11.1L14.07 12.195C14.6777 11.2402 15.0003 10.1318 15 9C15 5.685 12.315 3 9 3ZM9 13.5C6.5175 13.5 4.5 11.4825 4.5 9C4.5 8.2425 4.6875 7.5225 5.025 6.9L3.93 5.805C3.32231 6.75982 2.99969 7.86821 3 9C3 12.315 5.685 15 9 15V17.25L12 14.25L9 11.25V13.5Z",
    fill: "#4E5862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhance);
export default __webpack_public_path__ + "static/media/enhance.ce0f363bc322f588ef7b229058544099.svg";
export { ForwardRef as ReactComponent };